import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PARAM_KEYS } from "./constants";
import { deriveAnalyticsRouteContext } from "./routeContext";
import {
  clearPersistentContext,
  setPageContext,
  setPersistentContext,
  setUserContext,
  trackEvent,
  trackPageView,
} from "./client";

let lastTrackedLocationSignature = null;

const ROUTE_PERSISTENT_KEYS = [
  PARAM_KEYS.CATEGORY_KEY,
  PARAM_KEYS.ZIP_CODE,
  PARAM_KEYS.PROJECT_GUID,
  PARAM_KEYS.PROVIDER_ID,
];

export default function AnalyticsRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    const locationSignature = `${location.pathname}${location.search}${location.hash}`;

    if (locationSignature === lastTrackedLocationSignature) {
      return;
    }

    lastTrackedLocationSignature = locationSignature;

    const routeContext = deriveAnalyticsRouteContext(location);

    setUserContext({
      [PARAM_KEYS.IS_LOGGED_IN]: false,
    });
    setPageContext(routeContext.context);

    const nextPersistentContext = ROUTE_PERSISTENT_KEYS.reduce((accumulator, key) => {
      if (routeContext.context[key] !== undefined) {
        accumulator[key] = routeContext.context[key];
      }

      return accumulator;
    }, {});

    const staleKeys = ROUTE_PERSISTENT_KEYS.filter((key) => !(key in nextPersistentContext));

    if (staleKeys.length > 0) {
      clearPersistentContext(staleKeys);
    }

    if (Object.keys(nextPersistentContext).length > 0) {
      setPersistentContext(nextPersistentContext);
    }

    trackPageView(routeContext.context);

    if (routeContext.viewEventName) {
      trackEvent(routeContext.viewEventName, routeContext.context);
    }
  }, [location]);

  return null;
}